import { IS_PROD } from './config';
const url = window.location.search; // ?? document.referrer;
let debugParams = '';
if (!IS_PROD && url.indexOf('gtm_debug') > -1) {
    const regex = /(?:\?|&)gtm_debug=(.*)(?:&|$)/gm;
    const matches = [...(url.matchAll(regex) ?? [])];
    if (matches.length && matches[0].length > 1) {
        debugParams = `?gtm_debug=${matches[0][1]}`;
    }
}
export const COMMON_QUERY_PARAMS = debugParams;
